import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import DataSheet from 'wix-react-datasheet/lib';
import classNames from 'classnames';
import 'wix-rich-content-common/libs/Tooltip';
import { C as CELL_AUTO_MIN_WIDTH, a as CELL_MANUAL_MIN_WIDTH, T as TABLE_TYPE } from './viewer-loadable2.js';
import { s as styles$3, C as CellBorders } from './CellBorders.js';
import { cloneDeep, debounce } from 'lodash';
import { ToolbarType } from 'wix-rich-content-common';
import { s as styles$4 } from './table-viewer2.js';
import '@loadable/component';
import 'ricos-types';

function _createForOfIteratorHelperLoose$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$8(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$4.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$4) {
    for (var _iterator = _createForOfIteratorHelperLoose$4(__getOwnPropSymbols$4(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$4.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
    }
  }
  return a;
};
var DragAndDropIcon = function DragAndDropIcon(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: "9px",
    height: "13px",
    viewBox: "0 0 9 13"
  }, props), /* @__PURE__ */React.createElement("g", {
    id: "Symbols",
    stroke: "none"
  }, /* @__PURE__ */React.createElement("g", {
    id: "drag&drop/row/unselected",
    transform: "translate(-9.000000, -15.000000)",
    fill: "currentColor"
  }, /* @__PURE__ */React.createElement("g", {
    transform: "translate(14.000000, 21.500000) rotate(-270.000000) translate(-14.000000, -21.500000) translate(-7.000000, 8.000000)",
    id: "drag&drop/column"
  }, /* @__PURE__ */React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.000000, 10.000000)"
  }, /* @__PURE__ */React.createElement("path", {
    d: "M2,4.8 C2.62132034,4.8 3.13235254,5.26813868 3.19380454,5.87654553 L3.2,6 C3.2,6.62132034 2.73186132,7.13235254 2.12345447,7.19380454 L2,7.2 C1.3372583,7.2 0.8,6.66736221 0.8,6 C0.8,5.37867966 1.26813868,4.86764746 1.87654553,4.80619546 L2,4.8 Z M6,4.8 C6.62132034,4.8 7.13235254,5.26813868 7.19380454,5.87654553 L7.2,6 C7.2,6.62132034 6.73186132,7.13235254 6.12345447,7.19380454 L6,7.2 C5.3372583,7.2 4.8,6.66736221 4.8,6 C4.8,5.37867966 5.26813868,4.86764746 5.87654553,4.80619546 L6,4.8 Z M10,4.8 C10.6213203,4.8 11.1323525,5.26813868 11.1938045,5.87654553 L11.2,6 C11.2,6.62132034 10.7318613,7.13235254 10.1234545,7.19380454 L10,7.2 C9.3372583,7.2 8.8,6.66736221 8.8,6 C8.8,5.37867966 9.26813868,4.86764746 9.87654553,4.80619546 L10,4.8 Z",
    id: "Color"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M2,0.2 C2.62132034,0.2 3.13235254,0.66813868 3.19380454,1.27654553 L3.2,1.4 C3.2,2.02132034 2.73186132,2.53235254 2.12345447,2.59380454 L2,2.6 C1.3372583,2.6 0.8,2.06736221 0.8,1.4 C0.8,0.778679656 1.26813868,0.267647457 1.87654553,0.206195465 L2,0.2 Z M6,0.2 C6.62132034,0.2 7.13235254,0.66813868 7.19380454,1.27654553 L7.2,1.4 C7.2,2.02132034 6.73186132,2.53235254 6.12345447,2.59380454 L6,2.6 C5.3372583,2.6 4.8,2.06736221 4.8,1.4 C4.8,0.778679656 5.26813868,0.267647457 5.87654553,0.206195465 L6,0.2 Z M10,0.2 C10.6213203,0.2 11.1323525,0.66813868 11.1938045,1.27654553 L11.2,1.4 C11.2,2.02132034 10.7318613,2.53235254 10.1234545,2.59380454 L10,2.6 C9.3372583,2.6 8.8,2.06736221 8.8,1.4 C8.8,0.778679656 9.26813868,0.267647457 9.87654553,0.206195465 L10,0.2 Z",
    id: "Color"
  }))))));
};

({
  onClick: PropTypes.func.isRequired,
  dataHook: PropTypes.string,
  shouldDisable: PropTypes.bool,
  t: PropTypes.func
});

function _createForOfIteratorHelperLoose$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$7 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$7(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$3.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$3) {
    for (var _iterator = _createForOfIteratorHelperLoose$3(__getOwnPropSymbols$3(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$3.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$2 = function __spreadProps(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
var __publicField$6 = function __publicField(obj, key, value) {
  __defNormalProp$7(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var getStyleVal = function getStyleVal(elm, css) {
  return window.getComputedStyle(elm, null).getPropertyValue(css);
};
var paddingDiff = function paddingDiff(col) {
  if (getStyleVal(col, "box-sizing") === "border-box") {
    return 0;
  }
  var padLeft = getStyleVal(col, "padding-left");
  var padRight = getStyleVal(col, "padding-right");
  return parseInt(padLeft) + parseInt(padRight);
};
var getRefWidthAsNumber = function getRefWidthAsNumber(ref) {
  return getSizeStringAsNumber(ref.style.width);
};
var getSizeStringAsNumber = function getSizeStringAsNumber(str) {
  return parseInt(str.substring(0, str.length - 2));
};
var range = function range(start, end) {
  var array = [];
  var inc = end - start > 0;
  for (var i = start; inc ? i <= end : i >= end; inc ? i++ : i--) {
    inc ? array.push(i) : array.unshift(i);
  }
  return array;
};
var getRange = function getRange(_ref) {
  var start = _ref.start,
    end = _ref.end;
  var ranges = [];
  start && end && range(start.i, end.i).map(function (i) {
    return range(start.j, end.j).map(function (j) {
      return ranges.push({
        i: i,
        j: j
      });
    });
  });
  return ranges;
};
var TableDataUtil = function TableDataUtil(componentData) {
  var _this = this;
  __publicField$6(this, "updateComponentData", function (componentData) {
    _this.componentData = componentData;
  });
  //TABLE DATA GETTERS
  __publicField$6(this, "getRowColumns", function (i) {
    var _a;
    return (_a = _this.getRow(i)) == null ? void 0 : _a.columns;
  });
  __publicField$6(this, "getRows", function () {
    var _a, _b;
    return (_b = (_a = _this.componentData) == null ? void 0 : _a.config) == null ? void 0 : _b.rows;
  });
  __publicField$6(this, "getRow", function (i) {
    var _a;
    return (_a = _this.getRows()) == null ? void 0 : _a[i];
  });
  __publicField$6(this, "getRowNum", function () {
    return Object.entries(_this.getRows() || {}).length;
  });
  __publicField$6(this, "getColNum", function () {
    return Object.entries(_this.getRowColumns(0) || {}).length;
  });
  __publicField$6(this, "getCell", function (i, j) {
    return _this.getRow(i) && _this.getRowColumns(i)[j];
  });
  __publicField$6(this, "getCellContent", function (i, j) {
    var _a;
    return (_a = _this.getCell(i, j)) == null ? void 0 : _a.content;
  });
  __publicField$6(this, "getCellStyle", function (i, j) {
    var _a;
    return (_a = _this.getCell(i, j)) == null ? void 0 : _a.style;
  });
  __publicField$6(this, "getColsWidth", function () {
    return _this.componentData.config.colsWidth;
  });
  __publicField$6(this, "getRowsHeight", function () {
    return _this.componentData.config.rowsHeight;
  });
  __publicField$6(this, "getColWidth", function (j) {
    return _this.getColsWidth()[j];
  });
  __publicField$6(this, "getRowHeight", function (i) {
    return _this.getRowsHeight()[i];
  });
  __publicField$6(this, "getColsMinWidth", function () {
    return _this.componentData.config.colsMinWidth;
  });
  // get min width of column (in case we want min width for column with specific atomic plugins)
  __publicField$6(this, "getColMinWidth", function (j) {
    var colMinWidth = CELL_MANUAL_MIN_WIDTH;
    var numberOfRows = _this.getRowNum();
    var _loop = function _loop(i) {
      var content = _this.getCellContent(i, j);
      var contentState = content.getCurrentContent();
      contentState.getBlockMap().forEach(function (block) {
        if (block.type === "atomic") {
          var entityKey = block.getEntityAt(0);
          var entity = entityKey ? contentState.getEntity(entityKey) : void 0;
          var type = entity == null ? void 0 : entity.getType();
          if (type === "wix-draft-plugin-image" || type === "wix-draft-plugin-video") {
            colMinWidth = 300;
          }
        }
      });
    };
    for (var i = 0; i < numberOfRows; i++) {
      _loop(i);
    }
    return colMinWidth;
  });
  __publicField$6(this, "getCellWidthAsPixel", function (tableWidth, i, colsMinWidth) {
    if (colsMinWidth === void 0) {
      colsMinWidth = [];
    }
    var colsWidthSum = _this.getColsWidth().reduce(function (acc, val) {
      return acc + val;
    }, 0);
    var smallestCellIndex, smallestCellWidth, currCellWidth;
    _this.getColsWidth().forEach(function (width, index) {
      var cellWidth = tableWidth * (width / colsWidthSum);
      if (index === i) {
        currCellWidth = cellWidth;
      } else if (cellWidth < CELL_AUTO_MIN_WIDTH && (!smallestCellWidth || smallestCellWidth > cellWidth)) {
        smallestCellWidth = Math.max(colsMinWidth[index], cellWidth);
        smallestCellIndex = index;
      }
    });
    if (smallestCellWidth) {
      currCellWidth = Math.min(CELL_AUTO_MIN_WIDTH, smallestCellWidth) * (_this.getColWidth(i) / _this.getColWidth(smallestCellIndex));
    }
    return Math.max(currCellWidth, colsMinWidth[i]);
  });
  __publicField$6(this, "getCellWidthAsRatio", function (tableWidth, totalColsWidth, cellWidth) {
    return parseInt(totalColsWidth * cellWidth / tableWidth, 10);
  });
  //MERGE
  __publicField$6(this, "getCellMergeData", function (i, j) {
    var _a;
    return (_a = _this.getCell(i, j)) == null ? void 0 : _a.merge;
  });
  __publicField$6(this, "getParentCell", function (key) {
    var parentCell;
    Object.entries(_this.getRows()).forEach(function (_ref4) {
      var i = _ref4[0],
        row = _ref4[1];
      !parentCell && Object.entries(row.columns).forEach(function (_ref5) {
        var j = _ref5[0];
        var merge = _this.getCellMergeData(i, j);
        if ((merge == null ? void 0 : merge.key) === key) {
          parentCell = __spreadProps$2(__spreadValues$3({}, merge), {
            row: i,
            col: j
          });
        }
      });
    });
    return parentCell;
  });
  __publicField$6(this, "fixSelectedWithMergeCells", function (selected) {
    var selectedCells = getRange(selected);
    selectedCells.length > 1 && selectedCells.forEach(function (_ref6) {
      var i = _ref6.i,
        j = _ref6.j;
      var _ref7 = _this.getCellMergeData(i, j) || {},
        parentCellKey = _ref7.parentCellKey,
        rowSpan = _ref7.rowSpan,
        colSpan = _ref7.colSpan;
      var parentCell = parentCellKey && _this.getParentCell(parentCellKey);
      var extendSelectionBySpan = function extendSelectionBySpan(i2, j2, rowSpan2, colSpan2) {
        if (rowSpan2 > 1 || colSpan2 > 1) {
          [].concat(Array(rowSpan2).fill(0)).forEach(function (row, rowIndex) {
            [].concat(Array(colSpan2).fill(0)).forEach(function (col, colIndex) {
              var fixPos = function fixPos(key, newPos) {
                var start = selected.start[key] <= selected.end[key] ? selected.start : selected.end;
                var end = selected.start[key] <= selected.end[key] ? selected.end : selected.start;
                start[key] > newPos && (start[key] = newPos);
                end[key] < newPos && (end[key] = newPos);
              };
              fixPos("i", i2 + rowIndex);
              fixPos("j", j2 + colIndex);
            });
          });
        }
      };
      if (parentCell) {
        var row = parentCell.row,
          col = parentCell.col,
          rowSpan2 = parentCell.rowSpan,
          colSpan2 = parentCell.colSpan;
        extendSelectionBySpan(parseInt(row), parseInt(col), rowSpan2, colSpan2);
      } else {
        extendSelectionBySpan(i, j, rowSpan, colSpan);
      }
    });
    return selected;
  });
  __publicField$6(this, "getCellParentPosition", function (i, j) {
    var _ref8 = _this.getCellMergeData(i, j) || {},
      parentCellKey = _ref8.parentCellKey,
      rowSpan = _ref8.rowSpan,
      colSpan = _ref8.colSpan;
    if (parentCellKey) {
      var _this$getParentCell = _this.getParentCell(parentCellKey),
        row = _this$getParentCell.row,
        col = _this$getParentCell.col;
      return {
        i: row,
        j: col
      };
    } else if (rowSpan > 1 || colSpan > 1) {
      return {
        i: i,
        j: j
      };
    }
  });
  __publicField$6(this, "getRowCellsParentPosition", function (i) {
    var parentPos;
    Object.entries(_this.getRowColumns(i)).forEach(function (_ref9) {
      var j = _ref9[0];
      !parentPos && (parentPos = _this.getCellParentPosition(i, j));
    });
    return parentPos;
  });
  __publicField$6(this, "getColCellsParentPosition", function (j) {
    var parentPos;
    Object.entries(_this.getRows()).forEach(function (_ref10) {
      var i = _ref10[0];
      !parentPos && (parentPos = _this.getCellParentPosition(i, j));
    });
    return parentPos;
  });
  //SELECTION
  __publicField$6(this, "getRowsSelection", function (rowsIndexes) {
    return {
      start: {
        i: rowsIndexes.start,
        j: 0
      },
      end: {
        i: rowsIndexes.end,
        j: _this.getColNum() - 1
      }
    };
  });
  __publicField$6(this, "getColsSelection", function (colsIndexes) {
    return {
      start: {
        i: 0,
        j: colsIndexes.start
      },
      end: {
        i: _this.getRowNum() - 1,
        j: colsIndexes.end
      }
    };
  });
  __publicField$6(this, "getAllCellsSelection", function () {
    return {
      start: {
        i: 0,
        j: 0
      },
      end: {
        i: _this.getRowNum() - 1,
        j: _this.getColNum() - 1
      }
    };
  });
  __publicField$6(this, "isAllCellsSelected", function (start, end) {
    return start && end && Math.min(start.i, end.i) === 0 && Math.min(start.j, end.j) === 0 && Math.max(start.i, end.i) === _this.getRowNum() - 1 && Math.max(start.j, end.j) === _this.getColNum() - 1;
  });
  __publicField$6(this, "getSelectionStyle", function (selection, defaultBG, defaultBorder) {
    var _a, _b;
    var range2 = getRange(selection);
    var selectionBGColor = ((_a = _this.getCellStyle(range2[0].i, range2[0].j)) == null ? void 0 : _a.backgroundColor) || defaultBG;
    var selectionBorderColor = _this.getConsistentCellBorderColor(selection, range2[0].i, range2[0].j, defaultBorder);
    var selectionVerticalAlign = ((_b = _this.getCellStyle(range2[0].i, range2[0].j)) == null ? void 0 : _b.verticalAlign) || "top";
    var selectionBorderIsActive = false;
    range2.forEach(function (_ref11) {
      var i = _ref11.i,
        j = _ref11.j;
      var _a2, _b2;
      var currentCellBGColor = ((_a2 = _this.getCellStyle(i, j)) == null ? void 0 : _a2.backgroundColor) || defaultBG;
      if (selectionBGColor !== currentCellBGColor) {
        selectionBGColor = false;
      }
      var currentCellBorderColor = _this.getConsistentCellBorderColor(selection, i, j, selectionBorderColor);
      if (selectionBorderColor !== currentCellBorderColor) {
        selectionBorderColor = false;
      }
      if (_this.isCellBorderActive(selection, i, j)) {
        selectionBorderIsActive = true;
      }
      var currentVerticalAlign = ((_b2 = _this.getCellStyle(i, j)) == null ? void 0 : _b2.verticalAlign) || "top";
      if (selectionVerticalAlign !== currentVerticalAlign) {
        selectionVerticalAlign = false;
      }
    });
    return {
      selectionBGColor: selectionBGColor,
      selectionBorderColor: selectionBorderColor,
      selectionVerticalAlign: selectionVerticalAlign,
      selectionBorderIsActive: selectionBorderIsActive
    };
  });
  __publicField$6(this, "getSelectedRows", function (range2) {
    if (range2 === void 0) {
      range2 = [];
    }
    var colNum = _this.getColNum();
    return _this.getSelectedSection(range2, function (_ref12) {
      var i = _ref12.i,
        j = _ref12.j;
      return {
        key: i,
        value: j
      };
    }, colNum);
  });
  __publicField$6(this, "getSelectedCols", function (range2) {
    if (range2 === void 0) {
      range2 = [];
    }
    var rowNum = _this.getRowNum();
    return _this.getSelectedSection(range2, function (_ref13) {
      var i = _ref13.i,
        j = _ref13.j;
      return {
        key: j,
        value: i
      };
    }, rowNum);
  });
  __publicField$6(this, "getSelectedSection", function (range2, keyValueMapper, cellsNum) {
    var selectedCells = {};
    range2 == null ? void 0 : range2.forEach(function (range3) {
      var _keyValueMapper = keyValueMapper(range3),
        key = _keyValueMapper.key,
        value = _keyValueMapper.value;
      if (selectedCells[key]) {
        selectedCells[key].push(value);
      } else {
        selectedCells[key] = [value];
      }
    });
    var selected = [];
    Object.entries(selectedCells).forEach(function (_ref14) {
      var j = _ref14[0],
        col = _ref14[1];
      return col.length === cellsNum && selected.push(j);
    });
    return selected[0] && selected;
  });
  __publicField$6(this, "getCellBorderColor", function (selection, row, col) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var style = {};
    var range2 = getRange(selection);
    if (!range2.find(function (_ref15) {
      var i = _ref15.i,
        j = _ref15.j;
      return i === row && j === col - 1;
    })) {
      style.borderLeft = (_b = (_a = _this.getCell(row, col)) == null ? void 0 : _a.border) == null ? void 0 : _b.left;
    }
    if (!range2.find(function (_ref16) {
      var i = _ref16.i,
        j = _ref16.j;
      return i === row && j === col + 1;
    })) {
      style.borderRight = (_d = (_c = _this.getCell(row, col)) == null ? void 0 : _c.border) == null ? void 0 : _d.right;
    }
    if (!range2.find(function (_ref17) {
      var i = _ref17.i,
        j = _ref17.j;
      return i === row - 1 && j === col;
    })) {
      style.borderTop = (_f = (_e = _this.getCell(row, col)) == null ? void 0 : _e.border) == null ? void 0 : _f.top;
    }
    if (!range2.find(function (_ref18) {
      var i = _ref18.i,
        j = _ref18.j;
      return i === row + 1 && j === col;
    })) {
      style.borderBottom = (_h = (_g = _this.getCell(row, col)) == null ? void 0 : _g.border) == null ? void 0 : _h.bottom;
    }
    return Object.values(style);
  });
  __publicField$6(this, "getConsistentCellBorderColor", function (selection, row, col, defaultBorder) {
    var borderStyles = _this.getCellBorderColor(selection, row, col);
    var isBorderConsistent = borderStyles.every(function (borderStyle) {
      return borderStyle === borderStyles[0];
    });
    if (isBorderConsistent) {
      var borderColor = borderStyles[0] ? _this.getColorFromBorderStyle(borderStyles[0]) : defaultBorder;
      return borderColor;
    } else {
      return false;
    }
  });
  __publicField$6(this, "isCellBorderActive", function (selection, row, col) {
    var borderStyles = _this.getCellBorderColor(selection, row, col);
    return borderStyles.some(function (borderStyle) {
      return borderStyle !== void 0;
    });
  });
  __publicField$6(this, "getColorFromBorderStyle", function (borderStyle) {
    return borderStyle.includes("transparent") ? "transparent" : "#" + borderStyle.split("#")[1];
  });
  __publicField$6(this, "getCellBorders", function (selection, row, col, color) {
    var range2 = getRange(selection);
    var _ref19 = _this.getCellMergeData(row, col) || {},
      _ref19$rowSpan = _ref19.rowSpan,
      rowSpan = _ref19$rowSpan === void 0 ? 1 : _ref19$rowSpan,
      _ref19$colSpan = _ref19.colSpan,
      colSpan = _ref19$colSpan === void 0 ? 1 : _ref19$colSpan;
    var borderColor = color || "var(--ricos-settings-action-color, var(--ricos-action-color, #0261ff))";
    var borders = {};
    if (!range2.find(function (_ref20) {
      var i = _ref20.i,
        j = _ref20.j;
      return i === row && j === col - 1;
    })) {
      borders.left = borderColor;
    }
    if (!range2.find(function (_ref21) {
      var i = _ref21.i,
        j = _ref21.j;
      return i === row && j === col + colSpan;
    })) {
      borders.right = borderColor;
    }
    if (!range2.find(function (_ref22) {
      var i = _ref22.i,
        j = _ref22.j;
      return i === row - 1 && j === col;
    })) {
      borders.top = borderColor;
    }
    if (!range2.find(function (_ref23) {
      var i = _ref23.i,
        j = _ref23.j;
      return i === row + rowSpan && j === col;
    })) {
      borders.bottom = borderColor;
    }
    return borders;
  });
  __publicField$6(this, "getRowHeader", function () {
    return _this.componentData.config.rowHeader;
  });
  __publicField$6(this, "getColHeader", function () {
    return _this.componentData.config.colHeader;
  });
  __publicField$6(this, "isCellContainedInHeader", function (i, j) {
    return i === 0 && _this.getRowHeader() || j === 0 && _this.getColHeader();
  });
  this.updateComponentData(componentData);
};

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$6 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$6(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$2.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$2) {
    for (var _iterator = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$2.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
    }
  }
  return a;
};
var __publicField$5 = function __publicField(obj, key, value) {
  __defNormalProp$6(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var tableKeysToIgnoreOnEdit = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"];
var Cell = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Cell, _Component);
  function Cell() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    __publicField$5(_assertThisInitialized(_this), "selectCellContent", function () {
      var _this$props = _this.props,
        row = _this$props.row,
        col = _this$props.col,
        selectCellContent = _this$props.selectCellContent,
        isMobile = _this$props.isMobile;
      !isMobile && (selectCellContent == null ? void 0 : selectCellContent(row, col));
    });
    __publicField$5(_assertThisInitialized(_this), "isSingleCellSelected", function (selectedCells) {
      if (selectedCells === void 0) {
        selectedCells = {};
      }
      var _a, _b, _c, _d;
      return ((_a = selectedCells == null ? void 0 : selectedCells.start) == null ? void 0 : _a.i) === ((_b = selectedCells == null ? void 0 : selectedCells.end) == null ? void 0 : _b.i) && ((_c = selectedCells == null ? void 0 : selectedCells.start) == null ? void 0 : _c.j) === ((_d = selectedCells == null ? void 0 : selectedCells.end) == null ? void 0 : _d.j);
    });
    __publicField$5(_assertThisInitialized(_this), "isEditing", function (editing, selectedCells) {
      return editing && _this.isSingleCellSelected(selectedCells);
    });
    __publicField$5(_assertThisInitialized(_this), "setEditorRef", function (ref) {
      var _this$props2 = _this.props,
        setEditorRef = _this$props2.setEditorRef,
        row = _this$props2.row,
        col = _this$props2.col;
      _this.editorRef = ref;
      setEditorRef && setEditorRef(ref, row, col);
    });
    __publicField$5(_assertThisInitialized(_this), "setTdRef", function (ref) {
      return _this.tdRef = ref;
    });
    __publicField$5(_assertThisInitialized(_this), "getToolbarPosition", function () {
      if (_this.tdRef) {
        var cellOffsetLeft = _this.tdRef.offsetLeft;
        var tableWidth = _this.props.tableWidth;
        return {
          x: 0,
          containerWidth: tableWidth,
          offsetLeftInsideContainer: cellOffsetLeft
        };
      }
    });
    __publicField$5(_assertThisInitialized(_this), "onKeydown", function (e) {
      var _this$props3 = _this.props,
        editing = _this$props3.editing,
        onKeyDown = _this$props3.onKeyDown,
        isMobile = _this$props3.isMobile;
      if (editing && !isMobile) {
        if (e.key === "Backspace") {
          e.stopPropagation();
        } else if (e.key === "a" && (e.ctrlKey || e.metaKey)) {
          e.stopPropagation();
        }
        var shouldCreateNewLine = e.key === "Enter" && (e.altKey || e.shiftKey || e.metaKey);
        if (!tableKeysToIgnoreOnEdit.includes(e.key) && !shouldCreateNewLine) {
          onKeyDown(e);
        }
      } else if (!editing && tableKeysToIgnoreOnEdit.includes(e.key)) {
        onKeyDown(e);
        e.stopPropagation();
        e.preventDefault();
      }
    });
    __publicField$5(_assertThisInitialized(_this), "fixReactModalButtons", function (toolbarButtons) {
      Object.values(toolbarButtons).forEach(function (buttonsProps) {
        if (buttonsProps.type === "DROPDOWN") {
          buttonsProps.type = "modal";
        }
      });
    });
    __publicField$5(_assertThisInitialized(_this), "getEditorWrapperStyle", function (additionalStyles, isEditing) {
      var shouldSetEditStyle = !_this.props.isMobile && isEditing;
      var style = shouldSetEditStyle ? __spreadValues$2({
        minHeight: _this.tdHeight
      }, additionalStyles) : {};
      var verticalAlign = additionalStyles.verticalAlign;
      if (shouldSetEditStyle && verticalAlign) {
        style.display = "flex";
        if (verticalAlign === "middle") {
          style.alignItems = "center";
        } else if (verticalAlign === "bottom") {
          style.alignItems = "flex-end";
        }
      }
      return style;
    });
    __publicField$5(_assertThisInitialized(_this), "getCellBorders", function (cellBorders, shouldShowSelectedStyle) {
      var _this$props4 = _this.props,
        table = _this$props4.table,
        selectedCells = _this$props4.selectedCells,
        row = _this$props4.row,
        col = _this$props4.col,
        disableSelectedStyle = _this$props4.disableSelectedStyle,
        isMobile = _this$props4.isMobile,
        selected = _this$props4.selected;
      var cellSelectionBorders = table.getCellBorders(selectedCells, row, col);
      var borders = {};
      if (disableSelectedStyle && selected) {
        Object.entries(cellBorders).forEach(function (_ref) {
          var key = _ref[0],
            val = _ref[1];
          !cellSelectionBorders[key] && (borders[key] = val);
        });
      } else {
        borders = cellBorders;
      }
      return !isMobile && shouldShowSelectedStyle ? __spreadValues$2(__spreadValues$2({}, borders), cellSelectionBorders) : borders;
    });
    __publicField$5(_assertThisInitialized(_this), "hideBlocks", function () {
      var _this$props5 = _this.props,
        row = _this$props5.row,
        col = _this$props5.col,
        table = _this$props5.table,
        setEditorRef = _this$props5.setEditorRef;
      var editorState = table.getCellContent(row, col);
      var blocks = setEditorRef ? editorState.getCurrentContent().getBlocksAsArray() : editorState.blocks;
      if (blocks.length >= 3) {
        var lastBlockText;
        var firstBlockText;
        if (setEditorRef) {
          var currentContent = editorState.getCurrentContent();
          lastBlockText = currentContent.getLastBlock().getText();
          firstBlockText = currentContent.getFirstBlock().getText();
        } else {
          lastBlockText = blocks[blocks.length - 1].text;
          firstBlockText = blocks[0].text;
        }
        var hideFirstBlock = firstBlockText === "" || firstBlockText === "\u200B";
        var hideLastBlock = lastBlockText === "" || lastBlockText === "\u200B";
        return {
          hideFirstBlock: hideFirstBlock,
          hideLastBlock: hideLastBlock
        };
      } else {
        return {};
      }
    });
    __publicField$5(_assertThisInitialized(_this), "onCellClick", function () {
      return _this.props.isMobile && _this.props.onDoubleClick();
    });
    return _this;
  }
  var _proto = Cell.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _a, _b;
    var isCellWasEditing = this.isEditing(prevProps.editing, prevProps.selectedCells);
    var isCellEditing = this.isEditing(this.props.editing, this.props.selectedCells);
    var isGoIntoEdit = !isCellWasEditing && isCellEditing;
    var isGoOutFromEdit = isCellWasEditing && !isCellEditing;
    var _this$props6 = this.props,
      selectedCells = _this$props6.selectedCells,
      isMobile = _this$props6.isMobile,
      setEditingActive = _this$props6.setEditingActive,
      toolbarRef = _this$props6.toolbarRef;
    if (isGoIntoEdit) {
      this.editorRef.focus();
      setEditingActive(true);
      this.selectCellContent();
    } else if (isGoOutFromEdit) {
      setEditingActive(false);
      toolbarRef == null ? void 0 : toolbarRef.setEditingTextFormattingToolbarProps(false);
      this.selectCellContent();
    }
    if (this.props.selected && !prevProps.selected && !isCellEditing && !isMobile) {
      this.selectCellContent();
      selectedCells && getRange(selectedCells).length === 1 && ((_a = this.editorRef) == null ? void 0 : _a.focus());
      this.tdHeight = ((_b = this.tdRef) == null ? void 0 : _b.offsetHeight) - 1;
    }
  };
  _proto.render = function render() {
    var _a, _b, _c, _d, _e;
    var _this$props7 = this.props,
      row = _this$props7.row,
      col = _this$props7.col,
      style = _this$props7.style,
      onMouseDown = _this$props7.onMouseDown,
      onMouseOver = _this$props7.onMouseOver,
      onDoubleClick = _this$props7.onDoubleClick,
      editing = _this$props7.editing,
      onContextMenu = _this$props7.onContextMenu,
      children = _this$props7.children,
      selected = _this$props7.selected,
      selectedCells = _this$props7.selectedCells,
      table = _this$props7.table,
      isMobile = _this$props7.isMobile,
      disableSelectedStyle = _this$props7.disableSelectedStyle,
      setEditorRef = _this$props7.setEditorRef,
      selectCellContent = _this$props7.selectCellContent;
    var _ref2 = table.getCell(row, col) || {},
      _ref2$style = _ref2.style,
      additionalStyles = _ref2$style === void 0 ? {} : _ref2$style,
      _ref2$merge = _ref2.merge,
      merge = _ref2$merge === void 0 ? {} : _ref2$merge,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? {} : _ref2$border;
    var _merge$colSpan = merge.colSpan,
      colSpan = _merge$colSpan === void 0 ? 1 : _merge$colSpan,
      _merge$rowSpan = merge.rowSpan,
      rowSpan = _merge$rowSpan === void 0 ? 1 : _merge$rowSpan,
      parentCellKey = merge.parentCellKey;
    var isEditing = this.isEditing(editing, selectedCells);
    var shouldShowSelectedStyle = selected && !disableSelectedStyle && !isEditing;
    var range = selectedCells && getRange(selectedCells);
    var cellBorders = this.getCellBorders(border, shouldShowSelectedStyle);
    var isContainedInHeader = table.isCellContainedInHeader(row, col);
    var Tag = isContainedInHeader ? "th" : "td";
    var editorState = this.editorRef && isEditing && table.getCellContent(row, col);
    var Selection = editorState && editorState.getSelection();
    var cellContentContainText = editorState ? editorState.getCurrentContent().getBlockMap().filter(function (x) {
      return x.getType() === "unstyled";
    }).some(function (x) {
      return x.getText() !== "" && x.getText() !== "\u200B";
    }) : false;
    var showFormattingToolbar = this.editorRef && isEditing && (!Selection.isCollapsed() && Selection.getHasFocus() || document && document.querySelector('[data-id="rich-content-editor-modal"]')) && cellContentContainText;
    if (showFormattingToolbar) {
      var toolbarButtons = cloneDeep((_b = (_a = this.editorRef) == null ? void 0 : _a.getToolbarProps) == null ? void 0 : _b.call(_a, ToolbarType.FORMATTING));
      toolbarButtons && this.fixReactModalButtons(toolbarButtons);
      (_c = this.props.toolbarRef) == null ? void 0 : _c.setEditingTextFormattingToolbarProps(toolbarButtons);
    } else if (isEditing) {
      (_d = this.props.toolbarRef) == null ? void 0 : _d.setEditingTextFormattingToolbarProps(false);
    }
    var editorWrapperStyle = this.getEditorWrapperStyle(additionalStyles, isEditing);
    var _this$hideBlocks = this.hideBlocks(),
      hideFirstBlock = _this$hideBlocks.hideFirstBlock,
      hideLastBlock = _this$hideBlocks.hideLastBlock;
    return parentCellKey ? null :
    //eslint-disable-next-line
    /* @__PURE__ */
    React.createElement(Tag, {
      "data-hook": "table-plugin-cell",
      ref: this.setTdRef,
      className: classNames(styles$3.cell, isContainedInHeader && styles$3.header, shouldShowSelectedStyle && !isEditing && styles$3.selected),
      onMouseDown: onMouseDown,
      onMouseOver: onMouseOver,
      onDoubleClick: onDoubleClick,
      onClick: this.onCellClick,
      onContextMenu: onContextMenu,
      colSpan: colSpan,
      rowSpan: rowSpan,
      style: __spreadValues$2(__spreadValues$2({}, style), additionalStyles),
      onKeyDown: this.onKeydown
    }, /* @__PURE__ */React.createElement("div", {
      className: classNames(setEditorRef ? styles$3.editorWrapper : styles$3.viewerWrapper, !isEditing && hideFirstBlock && styles$3.hideFirstBlock, !isEditing && hideLastBlock && styles$3.hideLastBlock, !isMobile && isEditing && styles$3.editing, !isEditing && styles$3.disableSelection),
      style: editorWrapperStyle
    }, /* @__PURE__ */React.createElement(Editor, {
      editing: isMobile ? selected : isEditing,
      selected: selected,
      contentState: table.getCellContent(row, col),
      setEditorRef: this.setEditorRef,
      isEditor: selectCellContent
    }, children)), /* @__PURE__ */React.createElement(CellBorders, {
      borders: cellBorders
    }), /* @__PURE__ */React.createElement("div", {
      style: {
        height: shouldShowSelectedStyle ? (_e = this.tdRef) == null ? void 0 : _e.offsetHeight : 0
      },
      className: classNames(shouldShowSelectedStyle && styles$3.selected, (range == null ? void 0 : range.length) === 1 && styles$3.singleSelection)
    }));
  };
  return Cell;
}(Component);
var Editor = /*#__PURE__*/function (_Component2) {
  _inheritsLoose(Editor, _Component2);
  function Editor() {
    var _this2;
    _this2 = _Component2.apply(this, arguments) || this;
    __publicField$5(_assertThisInitialized(_this2), "setEditorRef", function (ref) {
      _this2.editor = ref;
      _this2.props.setEditorRef(ref);
    });
    return _this2;
  }
  var _proto2 = Editor.prototype;
  _proto2.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props8 = this.props,
      editing = _this$props8.editing,
      selected = _this$props8.selected,
      contentState = _this$props8.contentState;
    var isContentStateChanged = contentState !== nextProps.contentState;
    return editing || nextProps.editing || selected || isContentStateChanged;
  };
  _proto2.render = function render() {
    var _this$props9 = this.props,
      children = _this$props9.children,
      editing = _this$props9.editing,
      selected = _this$props9.selected;
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      /* @__PURE__ */
      React.createElement("div", {
        className: classNames(styles$3.editor, editing ? styles$3.edit : styles$3.view)
      }, /*#__PURE__*/React.cloneElement(children, {
        ref: this.setEditorRef,
        editing: editing,
        readOnly: !editing && !selected
      }))
    );
  };
  return Editor;
}(Component);
Editor.propTypes = {
  setEditorRef: PropTypes.func,
  selected: PropTypes.bool,
  editing: PropTypes.bool,
  children: PropTypes.any,
  contentState: PropTypes.object,
  setIsHighlighted: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
};
Cell.propTypes = {
  t: PropTypes.func,
  row: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  editing: PropTypes.bool,
  updated: PropTypes.bool,
  onMouseDown: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
  onContextMenu: PropTypes.func.isRequired,
  style: PropTypes.object,
  children: PropTypes.any,
  setDragsVisibility: PropTypes.func,
  table: PropTypes.object,
  setEditorRef: PropTypes.func,
  toolbarRef: PropTypes.any,
  selectedCells: PropTypes.object,
  setEditingActive: PropTypes.func,
  tableWidth: PropTypes.number,
  isMobile: PropTypes.bool,
  disableSelectedStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  onKeyDown: PropTypes.func,
  selectCellContent: PropTypes.func
};

var __defProp$5 = Object.defineProperty;
var __defNormalProp$5 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$4 = function __publicField(obj, key, value) {
  __defNormalProp$5(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var RowRenderer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RowRenderer, _Component);
  function RowRenderer() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    __publicField$4(_assertThisInitialized(_this), "setRef", function (ref) {
      var _a, _b;
      return (_b = (_a = _this.props).setRowRef) == null ? void 0 : _b.call(_a, ref, _this.props.row);
    });
    return _this;
  }
  var _proto = RowRenderer.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _a;
    return ((_a = nextProps.rowsToUpdate) == null ? void 0 : _a.includes(nextProps.row)) || false;
  };
  _proto.render = function render() {
    var _this$props = this.props,
      row = _this$props.row,
      children = _this$props.children,
      getRowHeight = _this$props.getRowHeight;
    var height = getRowHeight(row);
    return /* @__PURE__ */React.createElement("tr", {
      style: {
        height: height
      },
      ref: this.setRef
    }, children);
  };
  return RowRenderer;
}(Component);
RowRenderer.propTypes = {
  row: PropTypes.number.isRequired,
  children: PropTypes.any.isRequired,
  getRowHeight: PropTypes.func,
  setRowRef: PropTypes.func,
  rowsToUpdate: PropTypes.array
};

var styles$2 = {"container":"ZFjH2","dragAndDrop":"w6VRC","active":"_3-9lE","selectAll":"o15Yc","dragging":"aDHIl","horizontal":"P6Rjn","selectPreview":"iRY2z","vertical":"T3UgD"};

var __defProp$4 = Object.defineProperty;
var __defNormalProp$4 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$3 = function __publicField(obj, key, value) {
  __defNormalProp$4(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var DragAndDropSection = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DragAndDropSection, _React$Component);
  function DragAndDropSection(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    __publicField$3(_assertThisInitialized(_this), "removeShiftKey", function () {
      return _this.shiftKey = false;
    });
    __publicField$3(_assertThisInitialized(_this), "setShiftKey", function (e) {
      return e.key === "Shift" && (_this.shiftKey = true);
    });
    __publicField$3(_assertThisInitialized(_this), "onDragMouseDown", function (e, i) {
      _this.curDrag = e.target;
      _this.startPoint = _this.getEventDiff(e);
      if (_this.isActive(i)) {
        _this.clickedOnActiveDrag = true;
      } else {
        _this.drags = {};
        if (_this.shiftKey && _this.props.activeDrag) {
          _this.drags.start = Math.min(i, _this.props.activeDrag[0]);
          _this.drags.end = Math.max(i, _this.props.activeDrag[_this.props.activeDrag.length - 1]);
        } else {
          _this.drags.start = i;
          _this.drags.end = i;
        }
        _this.props.onDragClick(_this.drags);
      }
    });
    __publicField$3(_assertThisInitialized(_this), "getEventDiff", function (e) {
      return _this.props.horizontal ? e.pageX : e.pageY;
    });
    __publicField$3(_assertThisInitialized(_this), "onMouseMove", function (e) {
      var isDragging = _this.curDrag && (_this.isDragging || Math.abs(_this.startPoint - _this.getEventDiff(e)) > 25);
      if (isDragging) {
        var activeDrag = _this.props.activeDrag;
        _this.isDragging = true;
        _this.drags = {
          start: Math.min.apply(Math, activeDrag),
          end: Math.max.apply(Math, activeDrag)
        };
        _this.props.onDrag(e, _this.drags);
      }
    });
    __publicField$3(_assertThisInitialized(_this), "onMouseUp", function (e) {
      if (_this.clickedOnActiveDrag) {
        _this.props.onDragClick();
        _this.clickedOnActiveDrag = false;
      }
      if (_this.curDrag) {
        _this.curDrag = void 0;
        if (_this.isDragging) {
          _this.isDragging = void 0;
          _this.props.onDragEnd(e, _this.drags);
          _this.drags = null;
        }
      }
    });
    __publicField$3(_assertThisInitialized(_this), "isActive", function (i) {
      var _a;
      return (_a = _this.props.activeDrag) == null ? void 0 : _a.includes(i);
    });
    __publicField$3(_assertThisInitialized(_this), "getSelectedPreviewStyle", function () {
      var _this$props = _this.props,
        size = _this$props.size,
        horizontal = _this$props.horizontal,
        index = _this$props.index,
        selectAll = _this$props.selectAll;
      var selectPreviewStyle = {
        visibility: _this.isActive(index) && (selectAll ? horizontal : !selectAll) && "visible"
      };
      if (horizontal) {
        selectPreviewStyle.height = size ? size - 20 : 0;
        _this.isActive(index + 1) && (selectPreviewStyle.borderRight = "none");
        _this.isActive(index - 1) && (selectPreviewStyle.borderLeft = "none");
      } else {
        selectPreviewStyle.width = size;
        _this.isActive(index + 1) && (selectPreviewStyle.borderBottom = "none");
        _this.isActive(index - 1) && (selectPreviewStyle.borderTop = "none");
      }
      return selectPreviewStyle;
    });
    _this.state = {};
    return _this;
  }
  var _proto = DragAndDropSection.prototype;
  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
    document.addEventListener("keydown", this.setShiftKey);
    document.addEventListener("keyup", this.removeShiftKey);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
    document.removeEventListener("keydown", this.setShiftKey);
    document.removeEventListener("keyup", this.removeShiftKey);
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      horizontal = _this$props2.horizontal,
      selectAll = _this$props2.selectAll,
      index = _this$props2.index;
    var isActive = this.isActive(index);
    var selectPreviewStyle = this.getSelectedPreviewStyle();
    return /* @__PURE__ */React.createElement("div", {
      className: styles$2.container
    }, /* @__PURE__ */React.createElement("div", {
      className: classNames(styles$2.dragAndDrop, isActive && styles$2.active, selectAll && styles$2.selectAll, this.isDragging && styles$2.dragging),
      onMouseDown: function onMouseDown(e) {
        return _this2.onDragMouseDown(e, index);
      },
      "data-hook": (horizontal ? "col" : "row") + "Drag-" + index
    }, /* @__PURE__ */React.createElement(DragAndDropIcon, {
      className: classNames(horizontal && styles$2.horizontal),
      style: {
        visibility: !selectAll && isActive && "visible",
        cursor: this.isDragging ? "grabbing" : "grab"
      }
    })), /* @__PURE__ */React.createElement("div", {
      className: classNames(styles$2.selectPreview, !horizontal && styles$2.vertical),
      style: selectPreviewStyle
    }));
  };
  return DragAndDropSection;
}(React.Component);
DragAndDropSection.propTypes = {
  onDragClick: PropTypes.func.isRequired,
  horizontal: PropTypes.bool,
  selectAll: PropTypes.bool,
  onDragEnd: PropTypes.func.isRequired,
  onDrag: PropTypes.func.isRequired,
  activeDrag: PropTypes.array,
  index: PropTypes.number,
  size: PropTypes.number
};

var styles$1 = {"resizer":"IKJcp","horizonResizer":"xNeL9","verticalResizer":"S1Pqt","highlightOnly":"SgBwn"};

var __defProp$3 = Object.defineProperty;
var __defNormalProp$3 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$2 = function __publicField(obj, key, value) {
  __defNormalProp$3(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var RESIZER_STYLE = "1px solid #0000ff";
var Resizer = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Resizer, _PureComponent);
  function Resizer() {
    var _this;
    _this = _PureComponent.apply(this, arguments) || this;
    __publicField$2(_assertThisInitialized(_this), "getPosition", function (e) {
      return _this.props.horizontal ? e.pageX : e.pageY;
    });
    __publicField$2(_assertThisInitialized(_this), "getSize", function () {
      return _this.props.horizontal ? _this.curTarget.offsetWidth : _this.curTarget.offsetHeight;
    });
    __publicField$2(_assertThisInitialized(_this), "setNewSize", function (ref, size) {
      return _this.props.horizontal ? ref.style.width = size : ref.style.height = size;
    });
    __publicField$2(_assertThisInitialized(_this), "setMinSize", function (ref, size) {
      return ref.style.minWidth = size;
    });
    __publicField$2(_assertThisInitialized(_this), "onMouseDown", function (e) {
      var _this$props = _this.props,
        horizontal = _this$props.horizontal,
        size = _this$props.size,
        onResizeStart = _this$props.onResizeStart,
        index = _this$props.index,
        itemsRefs = _this$props.itemsRefs;
      horizontal ? _this.ref.style.height = size + "px" : _this.ref.style.width = size + "px";
      e.stopPropagation();
      _this.curTarget = itemsRefs[index];
      _this.siblingCell = horizontal && itemsRefs[index + 1];
      _this.position = _this.getPosition(e);
      var padding = paddingDiff(_this.curTarget);
      _this.curSize = horizontal ? getRefWidthAsNumber(_this.curTarget) : _this.getSize() - padding;
      _this.siblingSize = _this.siblingCell && getRefWidthAsNumber(_this.siblingCell);
      onResizeStart();
    });
    __publicField$2(_assertThisInitialized(_this), "onMouseMove", function (e) {
      if (_this.curTarget) {
        var diff = _this.getPosition(e) - _this.position;
        var newSize = _this.curSize + diff;
        var _this$props2 = _this.props,
          minSize = _this$props2.minSize,
          setContainerSize = _this$props2.setContainerSize,
          horizontal = _this$props2.horizontal,
          overflowWidth = _this$props2.overflowWidth;
        if (newSize >= minSize) {
          horizontal && newSize < CELL_AUTO_MIN_WIDTH && _this.setMinSize(_this.curTarget, newSize + "px");
          _this.setNewSize(_this.curTarget, newSize + "px");
          setContainerSize && setContainerSize(newSize + "px", _this.props.index);
          if (diff > 0 || diff <= 0 && overflowWidth <= 0) {
            var siblingNewSize = _this.siblingSize - diff;
            siblingNewSize && siblingNewSize >= CELL_AUTO_MIN_WIDTH && _this.setNewSize(_this.siblingCell, siblingNewSize + "px");
          }
        }
      }
    });
    __publicField$2(_assertThisInitialized(_this), "onMouseUp", function () {
      var _this$props3 = _this.props,
        horizontal = _this$props3.horizontal,
        onResize = _this$props3.onResize,
        index = _this$props3.index,
        itemsRefs = _this$props3.itemsRefs,
        minSize = _this$props3.minSize;
      horizontal ? _this.ref.style.height = "20px" : _this.ref.style.width = "20px";
      if (horizontal && _this.curTarget) {
        var cellWidth = getRefWidthAsNumber(_this.curTarget);
        var siblingWidth = _this.siblingCell && getRefWidthAsNumber(_this.siblingCell);
        cellWidth < minSize && (_this.curTarget.style.minWidth = cellWidth);
        siblingWidth && siblingWidth < minSize && (_this.siblingCell.style.minWidth = siblingWidth);
      }
      if (_this.curTarget && _this.position && _this.curSize) {
        horizontal ? onResize(itemsRefs) : onResize(index, _this.getSize());
        _this.curTarget = void 0;
        _this.position = void 0;
        _this.curSize = void 0;
      }
    });
    __publicField$2(_assertThisInitialized(_this), "getResizerStyle", function () {
      var _this$props4 = _this.props,
        horizontal = _this$props4.horizontal,
        highlightResizer = _this$props4.highlightResizer,
        index = _this$props4.index,
        size = _this$props4.size;
      var style = {};
      if (highlightResizer === index) {
        horizontal ? style = {
          height: size,
          borderRight: RESIZER_STYLE
        } : style = {
          width: size,
          borderBottom: RESIZER_STYLE,
          zIndex: 3
        };
      }
      return style;
    });
    __publicField$2(_assertThisInitialized(_this), "setRef", function (ref) {
      return _this.ref = ref;
    });
    return _this;
  }
  var _proto = Resizer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
  };
  _proto.render = function render() {
    var resizerStyle = this.getResizerStyle();
    return (
      //eslint-disable-next-line
      /* @__PURE__ */
      React.createElement("div", {
        className: classNames(styles$1.resizer, this.props.highlightOnly && styles$1.highlightOnly, this.props.horizontal ? styles$1.horizonResizer : styles$1.verticalResizer),
        style: resizerStyle,
        onMouseDown: this.onMouseDown,
        ref: this.setRef
      })
    );
  };
  return Resizer;
}(PureComponent);
Resizer.propTypes = {
  index: PropTypes.number.isRequired,
  size: PropTypes.number,
  onResize: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  horizontal: PropTypes.bool,
  minSize: PropTypes.number,
  onResizeStart: PropTypes.func,
  itemsRefs: PropTypes.any,
  setContainerSize: PropTypes.func,
  highlightOnly: PropTypes.bool,
  overflowWidth: PropTypes.number
};

var styles = {"container":"Dy4w2","selected":"z2Drv","selectAll":"-eCXo"};

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var Columns = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Columns, _PureComponent);
  function Columns() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = Columns.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      colNum = _this$props.colNum,
      colDragProps = _this$props.colDragProps,
      activeDrag = _this$props.activeDrag,
      selectAll = _this$props.selectAll,
      size = _this$props.size,
      onResize = _this$props.onResize,
      highlightResizer = _this$props.highlightResizer,
      onResizeStart = _this$props.onResizeStart,
      columnsRefs = _this$props.columnsRefs,
      tableOverflowWidth = _this$props.tableOverflowWidth;
    return /* @__PURE__ */React.createElement("tr", null, [].concat(Array(colNum).fill(0)).map(function (row, i) {
      return /* @__PURE__ */React.createElement("td", {
        key: "column" + i,
        className: classNames(styles.container, selectAll && styles.selectAll, (activeDrag == null ? void 0 : activeDrag.includes(i)) && styles.selected)
      }, /* @__PURE__ */React.createElement(DragAndDropSection, __spreadProps$1(__spreadValues$1({}, colDragProps), {
        horizontal: true,
        index: i,
        activeDrag: activeDrag,
        selectAll: selectAll,
        size: size
      })), onResize && /* @__PURE__ */React.createElement(Resizer, {
        onResize: onResize,
        highlightResizer: highlightResizer,
        horizontal: true,
        minSize: CELL_MANUAL_MIN_WIDTH,
        index: i,
        size: size,
        onResizeStart: onResizeStart,
        itemsRefs: columnsRefs,
        overflowWidth: tableOverflowWidth
      }));
    }));
  };
  return Columns;
}(PureComponent);
Columns.propTypes = {
  colDragProps: PropTypes.object,
  colNum: PropTypes.number.isRequired,
  activeDrag: PropTypes.array,
  selectAll: PropTypes.bool,
  size: PropTypes.number,
  onResize: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onResizeStart: PropTypes.func,
  columnsRefs: PropTypes.array,
  tableOverflowWidth: PropTypes.number
};

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$1 = function __publicField(obj, key, value) {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var TableRenderer = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(TableRenderer, _PureComponent);
  function TableRenderer(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    __publicField$1(_assertThisInitialized(_this), "onResizeWindow", debounce(function () {
      _this.setState({
        windowWidth: window.innerWidth
      });
      var _this$props = _this.props,
        table = _this$props.table,
        tableRef = _this$props.tableRef;
      tableRef.offsetWidth && _this.columns.forEach(function (col, i) {
        var width = table.getCellWidthAsPixel(tableRef.offsetWidth - 1, i, table.getColsMinWidth());
        col && (col.style.width = width + "px");
      });
    }, 60));
    _this.columns = [props.table.getColNum()];
    return _this;
  }
  var _proto = TableRenderer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener("resize", this.onResizeWindow);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("resize", this.onResizeWindow);
  };
  _proto.render = function render() {
    var _this2 = this;
    var _a;
    var _this$props2 = this.props,
      children = _this$props2.children,
      tableRef = _this$props2.tableRef,
      table = _this$props2.table,
      colDragProps = _this$props2.colDragProps,
      onResize = _this$props2.onResize,
      onResizeStart = _this$props2.onResizeStart,
      highlightResizer = _this$props2.highlightResizer,
      selected = _this$props2.selected,
      selectAll = _this$props2.selectAll,
      tableHeight = _this$props2.tableHeight,
      isEditMode = _this$props2.isEditMode,
      isEditingActive = _this$props2.isEditingActive,
      tableOverflowWidth = _this$props2.tableOverflowWidth;
    var range = selected && getRange(selected);
    var colsMinWidth = table.getColsMinWidth();
    this.columns = this.columns.filter(function (elem) {
      return elem.parentElement;
    });
    return /* @__PURE__ */React.createElement("table", {
      className: styles$4.container
    }, /* @__PURE__ */React.createElement("colgroup", null, table.getColsWidth().map(function (cellWidth, i) {
      return /* @__PURE__ */React.createElement("col", {
        key: i,
        ref: function ref(_ref) {
          return _ref && (_this2.columns[i] = _ref);
        },
        style: {
          width: (tableRef == null ? void 0 : tableRef.offsetWidth) ? table.getCellWidthAsPixel(tableRef.offsetWidth - 1, i, colsMinWidth) : cellWidth,
          minWidth: (colsMinWidth == null ? void 0 : colsMinWidth[i]) || CELL_AUTO_MIN_WIDTH
        }
      });
    })), /* @__PURE__ */React.createElement("thead", null, isEditMode && /* @__PURE__ */React.createElement(Columns, {
      colDragProps: colDragProps,
      colNum: table.getColNum(),
      onResize: onResize,
      onResizeStart: onResizeStart,
      highlightResizer: highlightResizer,
      activeDrag: isEditingActive ? [] : (_a = table.getSelectedCols(range)) == null ? void 0 : _a.map(function (i) {
        return parseInt(i);
      }),
      selectAll: selectAll,
      size: tableHeight,
      tableWidth: tableRef == null ? void 0 : tableRef.offsetWidth,
      columnsRefs: this.columns,
      tableOverflowWidth: tableOverflowWidth
    })), /* @__PURE__ */React.createElement("tbody", null, children));
  };
  return TableRenderer;
}(PureComponent);
TableRenderer.propTypes = {
  children: PropTypes.any,
  columns: PropTypes.any,
  table: PropTypes.any,
  tableRef: PropTypes.any,
  colDragProps: PropTypes.object,
  onResize: PropTypes.func,
  onResizeStart: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  selectAll: PropTypes.bool,
  tableHeight: PropTypes.number,
  isEditMode: PropTypes.bool,
  selected: PropTypes.object,
  isEditingActive: PropTypes.bool,
  tableOverflowWidth: PropTypes.number
};

({
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired
});

({
  rowDragProps: PropTypes.object.isRequired,
  size: PropTypes.number,
  activeDrag: PropTypes.array,
  selectAll: PropTypes.bool,
  onResize: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onResizeStart: PropTypes.func,
  isEditMode: PropTypes.bool,
  isSelectAllActive: PropTypes.bool,
  onSelectAllClick: PropTypes.func,
  rowNum: PropTypes.number,
  rowsHeights: PropTypes.array,
  isAllCellsSelected: PropTypes.bool,
  rowsRefs: PropTypes.array,
  rowsMaxContentHeight: PropTypes.array
});

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var TableViewer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TableViewer, _Component);
  function TableViewer(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    __publicField(_assertThisInitialized(_this), "cellCreator", function (i, j) {
      return {
        key: i + "-" + j,
        component: _this.renderCell(i, j),
        forceComponent: true,
        disableUpdatedFlag: true
      };
    });
    __publicField(_assertThisInitialized(_this), "renderCell", function (i, j) {
      var _this$props = _this.props,
        renderInnerRCE = _this$props.renderInnerRCE,
        innerRCV = _this$props.innerRCV;
      return renderInnerRCE ? renderInnerRCE(i, j) : innerRCV({
        contentState: _this.table.getCellContent(i, j),
        renderedIn: TABLE_TYPE
      });
    });
    __publicField(_assertThisInitialized(_this), "createRow", function (i, columnsNumber) {
      return [].concat(Array(columnsNumber).fill(0)).map(function (cell, j) {
        return _this.cellCreator(i, j);
      });
    });
    __publicField(_assertThisInitialized(_this), "sheetRenderer", function (props) {
      return /* @__PURE__ */React.createElement(TableRenderer, __spreadProps(__spreadValues({}, props), {
        table: _this.table,
        tableRef: _this.tableViewerRef,
        colDragProps: _this.props.colDragProps,
        onResize: _this.props.onResize,
        onResizeStart: _this.props.onResizeStart,
        highlightResizer: _this.props.highlightResizer,
        selectAll: _this.props.selectAll,
        tableHeight: _this.props.tableHeight,
        selected: _this.props.selected,
        isEditMode: _this.props.isEditMode,
        isEditingActive: _this.props.isEditingActive,
        tableOverflowWidth: _this.props.tableOverflowWidth
      }));
    });
    __publicField(_assertThisInitialized(_this), "rowRenderer", function (props) {
      return /* @__PURE__ */React.createElement(RowRenderer, __spreadProps(__spreadValues({}, props), {
        getRowHeight: _this.table.getRowHeight,
        setRowRef: _this.props.setRowRef,
        rowsToUpdate: _this.props.rowsToUpdate
      }));
    });
    __publicField(_assertThisInitialized(_this), "setCellRef", function (ref) {
      return _this.cellRef = ref;
    });
    __publicField(_assertThisInitialized(_this), "setTableViewerRef", function (ref) {
      _this.tableViewerRef = ref;
      if (!_this.state.isTableRefSet) {
        _this.setState({
          isTableRefSet: true
        });
      }
    });
    __publicField(_assertThisInitialized(_this), "cellRenderer", function (props) {
      var _this$props2 = _this.props,
        setEditorRef = _this$props2.setEditorRef,
        toolbarRef = _this$props2.toolbarRef,
        setEditingActive = _this$props2.setEditingActive,
        tableWidth = _this$props2.tableWidth,
        isMobile = _this$props2.isMobile,
        _this$props2$selected = _this$props2.selected,
        selected = _this$props2$selected === void 0 ? {} : _this$props2$selected,
        disableSelectedStyle = _this$props2.disableSelectedStyle,
        t = _this$props2.t,
        selectCellContent = _this$props2.selectCellContent;
      return /* @__PURE__ */React.createElement(Cell, __spreadProps(__spreadValues({}, props), {
        ref: _this.setCellRef,
        table: _this.table,
        setEditorRef: setEditorRef,
        toolbarRef: toolbarRef,
        selectedCells: selected,
        setEditingActive: setEditingActive,
        tableWidth: tableWidth,
        isMobile: isMobile,
        disableSelectedStyle: disableSelectedStyle,
        t: t,
        selectCellContent: selectCellContent
      }));
    });
    __publicField(_assertThisInitialized(_this), "valueRenderer", function (cell) {
      return cell.component;
    });
    _this.table = _this.props.table || new TableDataUtil(props.componentData);
    _this.state = {};
    return _this;
  }
  var _proto = TableViewer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.tableViewerRef.children[0].classList.add("has-custom-focus");
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props3 = this.props,
      onSelect = _this$props3.onSelect,
      selected = _this$props3.selected,
      isEditMode = _this$props3.isEditMode,
      setCellContent = _this$props3.setCellContent,
      onClear = _this$props3.onClear,
      onPaste = _this$props3.onPaste;
    var rowNum = this.table.getRowNum();
    var colNum = this.table.getColNum();
    var grid = [].concat(Array(rowNum).fill(0)).map(function (row, i) {
      return _this2.createRow(i, colNum);
    });
    return /* @__PURE__ */React.createElement("div", {
      className: classNames(isEditMode ? styles$4.editMode : styles$4.viewMode),
      ref: this.setTableViewerRef
    }, /* @__PURE__ */React.createElement(DataSheet, {
      data: grid,
      valueRenderer: this.valueRenderer,
      onSelect: onSelect,
      selected: selected || {},
      cellRenderer: this.cellRenderer,
      rowRenderer: this.rowRenderer,
      sheetRenderer: this.sheetRenderer,
      onClear: onClear,
      getCellContent: this.table.getCellContent,
      setCellContent: setCellContent,
      onPaste: onPaste
    }));
  };
  return TableViewer;
}(Component);
TableViewer.propTypes = {
  theme: PropTypes.object.isRequired,
  renderInnerRCE: PropTypes.func,
  innerRCV: PropTypes.func,
  table: PropTypes.object,
  onSelect: PropTypes.func,
  setRowRef: PropTypes.func,
  setEditorRef: PropTypes.func,
  toolbarRef: PropTypes.any,
  setEditingActive: PropTypes.func,
  columns: PropTypes.any,
  selected: PropTypes.object,
  componentData: PropTypes.object,
  tableWidth: PropTypes.number,
  isMobile: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool,
  t: PropTypes.func,
  disableSelectedStyle: PropTypes.bool,
  colDragProps: PropTypes.object,
  onResize: PropTypes.func,
  onResizeStart: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  selectAll: PropTypes.bool,
  tableHeight: PropTypes.number,
  isEditingActive: PropTypes.bool,
  setCellContent: PropTypes.func,
  onClear: PropTypes.func,
  onPaste: PropTypes.func,
  tableOverflowWidth: PropTypes.number,
  rowsToUpdate: PropTypes.array,
  selectCellContent: PropTypes.func
};

export { TableViewer as default };

import 'wix-rich-content-plugin-table/dist/loadable/viewer/es/styles.viewer.min.global.css'